import { useQuery, keepPreviousData } from '@tanstack/react-query';
import { api } from '@/lib/api';

export type ReportSummary = {
  range: { from: string; to: string };
  include_dummy: boolean;
  totals: { gross_inr: string; refunded_inr: string; net_inr: string; payments: number };
  revenue_by_day: { date: string; gross_inr: string; refunded_inr: string; net_inr: string; count: number }[];
  bookings_by_module: { module_type: string; count: number }[];
  bookings_by_status: { status: string; count: number }[];
  kyc_funnel: { kyc_status: string; count: number }[];
  top_vendors: { vendor_profile_id: string; business_name: string | null; net_inr: string; bookings: number }[];
  growth_by_day: { date: string; users: number; vendors: number }[];
};

export function use_report_summary(f: { from?: string; to?: string; include_dummy: boolean }) {
  return useQuery({
    queryKey: ['admin-report-summary', f],
    queryFn: async () => {
      const params: Record<string, string> = {};
      if (f.from) params.from = new Date(f.from).toISOString();
      if (f.to) params.to = new Date(`${f.to}T23:59:59`).toISOString();
      if (f.include_dummy) params.include_dummy = 'true';
      return (await api.get<ReportSummary>('/admin/reports/summary', { params })).data;
    },
    placeholderData: keepPreviousData,
  });
}
